/* eslint-disable max-len */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUncategorizedCategoryId } from '../containers/actions/resource_graphql_actions/content_graphql_api';

const initialState = {
	resources : {
		categories        : [],
		subCategories     : [],
		content           : [],
		sections          : [],
		networkCategories : [],
		networkResources  : [],
		categoryData      : {},
		uncategorizedId   : '' // uncategorized category id
	}
};

// Create async thunk for fetching uncategorized ID
export const fetchUncategorizedIdAsync = createAsyncThunk(
	'resources/fetchUncategorizedId',
	async (_, { getState }) =>
	{
		try
		{
			const companyId = getState()?.mysession?.session?.companyId;

			const response = await getUncategorizedCategoryId(companyId);

			if (response.success && response.data?.categoryId)
			{
				return response.data.categoryId;
			}
		}
		catch (error)
		{
			return '';
		}
	}
);

export const resourceSlice = createSlice({
	name     : 'resources',
	initialState,
	reducers : {
		fetchResourceData : (state, action) =>
		{
			state.resources = { ...state.resources, ...action.payload };
		},
		fetchUncategorizedId : (state, action) =>
		{
			state.uncategorizedId = action.payload;
		}
	},
	extraReducers : (builder) =>
	{
		builder
			.addCase(fetchUncategorizedIdAsync.fulfilled, (state, action) =>
			{
				state.uncategorizedId = action.payload;
			});
	}
});

export const { fetchResourceData, fetchUncategorizedId } = resourceSlice.actions;
export default resourceSlice.reducer;